import React from "react";
import IconHome from "./IconHome"
import IconVideo from "./IconVideo"
import IconChart from "./IconChart"
import IconGame from "./IconGame"
import IconArrowRight from "./IconArrowRight"
import IconArrowLeft from "./IconArrowLeft"
import IconMoodle from "./IconMoodle"
import IconPix from "./IconPix"
import IconUTC from "./IconUTC"
import IconComputer from "./IconComputer"
import IconPeople from "./IconPeople"
import IconCertification from "./IconCertification"
import IconQuizz from "./IconQuizz"
import IconDownload from "./IconDownload"
import IconHamburger from "./IconHamburger"

const Icon = (props) => {
    switch (props.name) {
        case 'home':
            return <IconHome {...props} />
        case 'chart':
            return <IconChart {...props} />
        case 'video':
            return <IconVideo {...props} />
        case 'game':
            return <IconGame {...props} />
        case 'arrow-right':
            return <IconArrowRight {...props} />
        case 'arrow-left':
            return <IconArrowLeft {...props} />
        case 'moodle':
            return <IconMoodle {...props} />
        case 'pix':
            return <IconPix {...props} />
        case 'utc':
            return <IconUTC {...props} />
        case 'certification':
            return <IconCertification {...props} />
        case 'computer':
            return <IconComputer {...props} />
        case 'people':
            return <IconPeople {...props} />
        case 'quizz':
            return <IconQuizz {...props} />
        case 'download':
            return <IconDownload {...props} />
        case 'hamburger':
            return <IconHamburger {...props} />
        default:
            return <IconHome {...props} />
    }
};

export default Icon;
